module.exports = __webpack_public_path__ + "images/6314e28d02585df1c2896923ecb8bb80.svg";